exports = module.exports = require("../../../../node_modules/_css-loader@0.28.11@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (max-width:1425px){\n    .float_win {\n        width: 0px !important;\n        overflow: hidden !important;\n    }\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/apple/Documents/object/chinaicac-portal/src/app/about/about-index/media.css
// module id = ../../../../../src/app/about/about-index/media.css
// module chunks = main